module.exports = __webpack_public_path__ + "img/left_checked.cf75be79.png";